import { TextInput as WalrusTextInput, style } from '@do/walrus';
import styled from 'styled-components';
import errorIcon from '../assets/error-icon.svg';
import vars from '../assets/overwrite-vars.scss';

const TextInput = styled(WalrusTextInput)`
  && {
    margin-top: ${style.vars.whitespace.regular};
    font-size: 1rem;
    line-height: 1.5rem;

    label {
      color: ${vars.primary};
      font-size: 1rem;
      text-transform: lowercase;

      & span {
        color: ${vars.red_dark};
      }
    }

    input {
      border: ${style.vars.borderWidth.thin} solid #8794b0;
      border-radius: ${vars.border_radius_large};
      background: ${vars.white};
      box-sizing: border-box;
    }
  }

  &.is-invalid input {
    border-color: ${vars.red_dark} !important;
  }

  &.is-invalid svg {
    display: none;
  }

  &.is-invalid > :last-child::before {
    content: url('${errorIcon}');
    margin-right: ${style.vars.whitespace.xsmall};
    height: ${style.vars.height.xsmall};
  }

  &.is-invalid > :last-child > div {
    font-size: ${style.vars.fontSize.small};
    line-height: ${style.vars.height.xsmall};
    color: ${vars.red_darkest};
    font-weight: ${style.vars.fontWeight.base};
  }
`;

export default TextInput;
